export const BASE_URL = process.env.REACT_APP_BASE_URL || 'https://dev.api.kolo-app.com/api';
export const MAPS_API_KEY = 'AIzaSyC7DEDOo6RVV2NGc2YiKV1P8Uopfr286pg';
